import { render } from "./DetailUserPic.vue?vue&type=template&id=0dc95f98&scoped=true"
import script from "./DetailUserPic.vue?vue&type=script&lang=js"
export * from "./DetailUserPic.vue?vue&type=script&lang=js"

import "./DetailUserPic.vue?vue&type=style&index=0&id=0dc95f98&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0dc95f98"

export default script